export class SecurityPremium {
    constructor(public data: {
        StartTime?: String,
        EndTime?: String,
        Duration?: Number,
        Age?: Number,
        Gender?: String,
        HazardLevel?: Number,
        PaymentFrequency?: Number,
        CigarettesPerDay?: Number,
        Height?: Number,
        Weight?: Number,
        DeathByAccident?: Number,
        InvalidityByAccident?: Number,
        Surgery?: Number,
        MonthlyRent?: Number,
        DailyFee?: Number,
        TreatmanExpenses?: Number,
        IncludeMSO?: Boolean,
        IncludeDNA?: Boolean,
        AdditionalInsurance?: Boolean,
        SelectedPackage?: Number,
        SumInsured?: Number,
        riderDeath?: Number,
        tbType?: Number,
        riderTB?: Number
    }) { }
}